var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 12 10",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.35 5h11.3c.1932997 0 .35.15670034.35.35v1.3c0 .19329966-.1567003.35-.35.35h-11.3c-.19329966 0-.35-.15670034-.35-.35v-1.3c0-.19329966.15670034-.35.35-.35z",
    transform: "matrix(-1 0 0 1 20 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.35 13h11.3c.1932997 0 .35.1567003.35.35v1.3c0 .1932997-.1567003.35-.35.35h-11.3c-.19329966 0-.35-.1567003-.35-.35v-1.3c0-.1932997.15670034-.35.35-.35z",
    transform: "matrix(-1 0 0 1 20 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9,
    rx: 0.35,
    width: 2,
    x: 4,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9,
    rx: 0.35,
    width: 2,
    x: 14,
    y: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14.4700011 6.75 1.0599978 1.69599661-5 3.12499999c-.3242702.2026689-.73572756.2026689-1.05999784 0l-5-3.12499999 1.05999788-1.69599661 4.47000106 2.79375066z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.b97b922844c45f9fc72156372fdd9ffb.svg";
export { ForwardRef as ReactComponent };